import {UISprite} from "../UI/Tools/Base/UISprite";
import {gsap} from "gsap";

export class SlotMan extends UISprite {
    Awake() {
        super.Awake();

        this.rightHand = this.addChild(new UISprite("slots/slotmanHand"));
        this.rightHand.anchor.set(0, 0.5);
        this.rightHand.position.set(150, 0);

        this.leftHand = this.addChild(new UISprite("slots/slotmanHand2"));
        this.leftHand.anchor.set(1, 0.5);
        this.leftHand.position.set(0, 50);

        this.body = this.addChild(new UISprite("slots/slotman"));

        this._animation = null;
    }

    animate() {
        if (this._animation) return;

        this.leftHand.rotation = -Math.PI * 0.05;
        this.rightHand.rotation = Math.PI * 0.05;
        this._animation = gsap.timeline({
            repeat: -1,
            repeatDelay: 0,
            yoyo: true,
        })
            .to(this.leftHand, {rotation: Math.PI * 0.05, duration: 1}, 0)
            .to(this.rightHand, {rotation: Math.PI * -0.05, duration: 1}, 0)
        ;
    }

    stop() {
        if (this._animation) {
            this._animation.kill();
            this._animation = null;
        }
    }
}
